"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = require("react-responsive");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DesktopMenuItem = _interopRequireDefault(require("./DesktopMenuItem"));

var _MobileMenuItem = _interopRequireDefault(require("./MobileMenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponsiveMenuItem = function ResponsiveMenuItem(props) {
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1040px)'
  });
  return isDesktop ? _react.default.createElement(_DesktopMenuItem.default, props) : _react.default.createElement(_MobileMenuItem.default, props);
};

var MenuItem = (0, _styledComponents.default)(ResponsiveMenuItem).withConfig({
  displayName: "MenuItem",
  componentId: "sc-1wke5xm-0"
})([""]);
var _default = MenuItem;
exports.default = _default;